// src/services/devoluciones.js
import api from "@/services/apiClient";

const V2 = "/api/v2";

export const listarDevoluciones = (payload) =>
  api.post(`${V2}/devoluciones`, payload ?? {});

export const detalleDevolucion = (id) =>
  api.post(`${V2}/devoluciones/detalle`, { id });

export const crearDevolucion = (payload) =>
  api.post(`${V2}/devoluciones/crear`, payload);

export const listarPedidosBloqueadosDevolucion = (payload = {}) =>
  api.post(`${V2}/devoluciones/pedidosBloqueados`, payload);

export const obtenerFiltrosDevoluciones = (payload = {}) =>
  api.post(`${V2}/devoluciones/filtros`, payload);

export const crearDevolucionMasiva = (payload) =>
  api.post(`${V2}/devoluciones/masiva`, payload);